import { Component, EventEmitter, OnInit, Output, ViewChild, ElementRef, ViewContainerRef } from '@angular/core';
import { DistrictDropdownComponent } from '../../../common-components/district/district-dropdown/district-dropdown.component';
import { SearchByDistrictsLayerComponent } from 'src/app/component/system/school-districts/search-by-districts-layer/search-by-districts-layer.component';
import { MsinMatTableDistrictsComponent } from '../msin-mat-table-districts/msin-mat-table-districts.component';
import { CountyDropdownComponent } from 'src/app/component/common-components/county/county-dropdown/county-dropdown.component';
import { RegionDropdownComponent } from 'src/app/component/common-components/region/region-dropdown/region-dropdown.component';
import { DistrictsLocationLayerComponent } from '../districts-location-layer/districts-location-layer.component';
// models
import { County } from 'src/app/model/county';
import { SchoolDistrict } from 'src/app/model/schoolDistrict.model';
import { PARTYROLE, Region } from 'src/app/model/region.model';

// services
import { MatDialog } from '@angular/material/dialog';
import { DistrictEntityService } from 'src/app/component/common-components/service/district-entity.service';
import { CountyEntityService } from 'src/app/component/common-components/service/county-entity.service';
import { RegionEntityService } from '../../../common-components/service/region-entity.service';
import { ApiSchoolDistrictsService } from 'src/app/service/api-school-districts.service';
import { OrganizationService } from '../../../common-components/organizations/service/organization.service';

// for backup/restore setup
import * as _moment from 'moment';
import { default as _rollupMoment } from 'moment';

// for Auth
import { UserProfileService } from 'src/app/component/user-profile/service/user-profile.service';
import { User } from 'src/app/component/auth/model/user.model';

const moment = _rollupMoment || _moment;

export const MY_FORMATS = {
    parse: {
        dateInput: 'LL'
    },
    display: {
        dateInput: 'LL',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY'
    }
};

@Component({
    selector: 'app-search-school-districts',
    templateUrl: './search-school-districts.component.html',
    styleUrls: ['./search-school-districts.component.scss']
})
export class SearchSchoolDistrictsComponent implements OnInit {
    @ViewChild(MsinMatTableDistrictsComponent) child!: MsinMatTableDistrictsComponent;
    @ViewChild(SearchByDistrictsLayerComponent) child2!: SearchByDistrictsLayerComponent;
    // @ViewChild(DistrictComponent) child3!: DistrictComponent;
    @ViewChild(RegionDropdownComponent) child4!: RegionDropdownComponent;
    @ViewChild(CountyDropdownComponent) child5!: CountyDropdownComponent;
    @ViewChild(DistrictsLocationLayerComponent) child6!: DistrictsLocationLayerComponent;
    @Output() eventEmitterSchoolsCountycode = new EventEmitter<County[]>();
    @Output() eventEmitterSchoolsRegioncode = new EventEmitter<Region[]>();
    @Output() eventEmitterSchoolsDistrictcode = new EventEmitter<SchoolDistrict[]>();
    // CREATE I/O props here
    @ViewChild('child') child7!: DistrictDropdownComponent;
    @ViewChild('ssid') fieldSSID!: ElementRef;

    @Output() eventEmitterDistrictcode = new EventEmitter<SchoolDistrict[]>();
    @Output() eventEmitterCountycode = new EventEmitter<County[]>();
    @Output() eventEmitterRegioncode = new EventEmitter<Region[]>();

    @Output() btnClick = new EventEmitter(); // to disable school code buttons when not in edit mode
    @Output() btnClick2 = new EventEmitter(); // to disable school code buttons when not in edit mode

    bShowCreateForm: boolean = false;
    createBtnText: string = 'Create';
    bCancelCreate: boolean = false;
    allSchoolDistricts: SchoolDistrict[] = [];
    allSchoolCounties: County[] = [];
    allSchoolRegions: Region[] = [];
    buttonLocation: string = 'top';
    filterPlaceholder: string = 'Filter items below';
    selectLabel1: string = 'Select Region(s)';
    selectLabel2: string = 'Select County(s)';
    selectLabel3: string = 'Select School District(s)';
    showDistrictDropdown: boolean = false;
    bShowMultipleSearchError: boolean = false;
    isLoadingResults = false;
    searchParm: any = [{}];
    searchFilter: any = [{}];
    counties: any = [{}];
    regions: any = [{}];
    districts: any = [{}];
    selectedCounties: any = [];
    selectedRegions: any = [];
    selectedDistricts: any = [];
    isUneditable: boolean = true;
    bShowSearchForm: boolean = true;
    schoolRegionIds: number[] = [];
    schoolDistrictIds: number[] = [];
    dataSource = [{}];
    partyRoles: PARTYROLE[] = [];
    user: User = {};
    isCreated: boolean = false;
    myError: string = '';
    ncesCode: string = '';
    selectedNcesCode: string = '';
    schoolDistrict: SchoolDistrict;

    constructor(
        private dialog: MatDialog,
        private _organizationService: OrganizationService,
        private schoolDistrictsAPIService: ApiSchoolDistrictsService,
        private schoolCountyService: CountyEntityService,
        private schoolRegionService: RegionEntityService,
        private userProfileService: UserProfileService,
        private viewContainerRef: ViewContainerRef,
        private schoolDistrictService: DistrictEntityService
    ) {
        this.subscribers();
    }

    ngOnInit(): void {
        this.isLoadingResults = true;
        console.log('searchSchoolDistricts ngOnInit call:');
    }

    ngAfterViewInit() {
        console.log('searchSchoolDistricts ngAfterViewInit call:');
        this.isLoadingResults = true;

        try {
            this.bShowMultipleSearchError = false;
            if (this.searchParm?.searchParms) {
                console.log('now attempting to set schoolDistrictName from backup search package');
                if (this.searchParm?.searchParms['schoolDistrictName']?.length > 0) {
                    this.child2?.searchSchoolDistrictsForm?.controls['schoolDistrictName'].setValue(this.searchParm?.searchParms['schoolDistrictName']);
                }
                if (this.searchParm?.searchParms['schoolDistrictCode']?.length > 0) {
                    this.child2?.searchSchoolDistrictsForm?.controls['schoolDistrictCode'].setValue(this.searchParm?.searchParms['schoolDistrictCode']);
                }
                if (this.searchParm?.searchParms['schoolDistrictNCES']?.length > 0) {
                    this.child2?.searchSchoolDistrictsForm?.controls['schoolDistrictNCES'].setValue(this.searchParm?.searchParms['schoolDistrictNCES']);
                }
            }
            if (this.searchParm['chosenCounty']?.length > 0) {
                //console.log("found county parm set from backup")
                //console.log("compare with user profile region: " + this.selectedCounties)
                if (this.selectedCounties?.length == 0) {
                    const countyEntries: any = Object.values(this.searchParm.chosenCounty);

                    let myCountyFromBackup: County = countyEntries[0];
                    //console.log(myCountyFromBackup?.ID);

                    if (myCountyFromBackup?.ID) {
                        this.child6?.child3?.selectedCountyIds.push(myCountyFromBackup.ID);
                        this.child6?.child3?.select(myCountyFromBackup?.ID);
                        //console.log("backupService was able to set county from localStorage as: " + myCountyFromBackup?.ID)
                        console.log(this.child6?.child3?.selectedCountyIds);
                    } else {
                        console.log('problem reading ID');
                    }
                }
            }
            if (this.searchParm['chosenRegions']?.length > 0) {
                //console.log("found region parm set from backup")
                //console.log("compare with user profile region: " + this.selectedRegions)
                if (this.selectedRegions?.length == 0) {
                    const regionEntries: any = Object.values(this.searchParm.chosenRegions);

                    let myRegionFromBackup: Region = regionEntries[0];
                    //console.log(myRegionFromBackup?.ID);
                    setTimeout(() => {
                        if (myRegionFromBackup?.ID) {
                            //    console.log("backupService was able to set region from localStorage as: " + myRegionFromBackup?.ID)
                        } else {
                            console.log('problem reading ID');
                        }
                    });
                }
            }
            if (this.searchParm['chosenSchoolDistricts']?.length > 0) {
                //console.log("found school district parm set from backup")
                //console.log("compare with user profile region: " + this.selectedDistricts)
                if (this.selectedDistricts?.length == 0) {
                    const districtEntries: any = Object.values(this.searchParm.chosenSchoolDistricts);

                    let myDistrictFromBackup: SchoolDistrict = districtEntries[0];
                    //console.log(myDistrictFromBackup?.ID);

                    if (myDistrictFromBackup?.ID) {
                        this.child6?.child?.selectedSchoolDistrictIds.push(myDistrictFromBackup?.ID);
                        //  console.log("backupService was able to set district from localStorage as: " + myDistrictFromBackup?.ID)
                    } else {
                        console.log('problem reading ID');
                    }
                }
            }
            // now run the search - BL does not want this autorun anymore
            //this.child2.fnSearch();
        } catch (Err) {
            console.log('error caught loading in ngAfterViewInit: ' + Err);
        }
        this.isLoadingResults = false;
        this.bShowMultipleSearchError = false;
    }

    onIsLoadingResultsEvent(isLoading: any) {
        this.isLoadingResults = isLoading;
    }

    onRegionChangeEvent(regionSet: any) {
        // let regionId: number = regionSet['ID'];
        // let bRerunSearchWithNewRegion: boolean = true;
        // let addTheseRegions: number[] = [];
        // addTheseRegions.push(regionId);
        // if (this.child6.child2.selectedRegionIds) {
        //     this.child6.child2.selectedRegionIds.forEach((thisRegionId) => {
        //         if (regionId == thisRegionId) {
        //             bRerunSearchWithNewRegion = false;
        //         } else {
        //             addTheseRegions.push(thisRegionId);
        //         }
        //     });
        // }
        // if (bRerunSearchWithNewRegion) {
        //     console.log('Rerun search with new region:');
        //     console.log(this.child6.child2.selectRegionIds);
        //     addTheseRegions.forEach((thisRegion) => {
        //         this.child6.child2.selectRegionIds.push(thisRegion);
        //         this.child6.child2.selectedRegionIds.push(thisRegion);
        //         this.child6.child2.select(thisRegion);
        //     });
        //     console.log('Running onSearchParmLessEvent with: ');
        //     console.log(this.child6.child2.selectedRegionIds);
        //     console.log(this.child6.child2.selectRegionIds);
        //     this.onSearchParmLessEvent(this.child6.child2.selectRegionIds);
        // } else {
        //     this.onSearchParmLessEvent(this.child6.child2.selectedRegionIds);
        // }
    }

    fnGetActualLen(myObj: any) {
        var len = 0;
        if (myObj == undefined) {
            len = 0;
        } else {
            for (var i = 0; i < myObj?.length; i++) {
                if (Object.keys(myObj[i]) !== undefined) {
                    len++;
                }
            }
        }
        return len;
    }

    onSearchParmEvent(inSearchParm: any) {
        console.log('search-school-districts searchParm is');
        if (this.isLoadingResults && this.bShowMultipleSearchError) {
            this.child2.myError = 'Canceled last attempt with a new attempt...';
        }
        this.searchParm = inSearchParm;

        console.log(this.searchParm);
        this.child.searchParm = inSearchParm;
        let bCountysIsBlank: Boolean = false;
        let bRegionsIsBlank: Boolean = false;
        let bDistrictsIsBlank: Boolean = false;
        let countiesShell: County[] = [];
        this.child.chosenCounties = countiesShell;

        this.child6?.child3?.selectedCountyIds.forEach((x) => {
            let countyShell: County = new County();
            countyShell.ID = x;
            this.child.chosenCounties.push(countyShell);
        });
        this.selectedCounties = this.child.chosenCounties;
        if (this.selectedCounties) {
            if (this.fnGetActualLen(this.selectedCounties) == 0) {
                bCountysIsBlank = true;
                console.log('counties is blank');
            }
        } else {
            console.log('counties was undefined');
            bCountysIsBlank = true;
        }
        if (this.selectedRegions) {
            if (this.fnGetActualLen(this.selectedRegions) == 0) {
                // console.log("regions is blank")
                bRegionsIsBlank = true;
            } else {
                this.child.chosenRegions = this.selectedRegions;
            }
        } else {
            console.log('regions was undefined');
            bRegionsIsBlank = true;
        }

        if (this.selectedCounties?.length > 0) {
            this.child.chosenCounties = this.selectedCounties;
        }
        if (this.selectedRegions?.length > 0) {
            this.child.chosenRegions = this.selectedRegions;
        }
        this.child.chosenRegions = this.selectedRegions;
        this.child.getSpecificSchoolDistricts(true);
        this.bShowMultipleSearchError = true;
    }

    onSearchParmLessEvent(inRegions: number[]) {
        // this method only called if a region changed during editschool
        console.log('calling onSearchParmLessEvent');
        this.child.searchParm = this.searchParm;
        let bCountysIsBlank: Boolean = false;
        let bRegionsIsBlank: Boolean = false;
        let bDistrictsIsBlank: Boolean = false;
        this.selectedCounties = this.child.chosenCounties;
        if (this.selectedCounties) {
            if (this.fnGetActualLen(this.selectedCounties) == 0) {
                bCountysIsBlank = true;
                console.log('counties is blank');
            }
        } else {
            console.log('counties was undefined');
            bCountysIsBlank = true;
        }
        this.selectedDistricts = this.child.chosenSchoolDistricts;
        if (this.selectedDistricts) {
            if (this.fnGetActualLen(this.selectedDistricts) == 0) {
                bDistrictsIsBlank = true;
                console.log('districts is blank');
            }
        } else {
            console.log('districts was undefined');
            bDistrictsIsBlank = true;
        }
        this.selectedRegions = inRegions;

        if (this.selectedRegions) {
            if (this.fnGetActualLen(this.selectedRegions) == 0) {
                console.log('regions is blank');
                bRegionsIsBlank = true;
            } else {
                this.child.chosenRegions = this.selectedRegions;
            }
        } else {
            console.log('regions was undefined');
            bRegionsIsBlank = true;
        }
        if (
            ((this.searchParm['schoolName'] === null || this.searchParm['schoolName'] == '') &&
                (this.searchParm['schoolAddress'] === null || this.searchParm['schoolAddress'] == '') &&
                (this.searchParm['cdsCode1'] === null || this.searchParm['cdsCode1'] == '') &&
                (this.searchParm['cdsCode2'] === null || this.searchParm['cdsCode2'] == '') &&
                (this.searchParm['cdsCode3'] === null || this.searchParm['cdsCode3'] == '') &&
                (this.searchParm['schoolCity'] === null || this.searchParm['schoolCity'] == '')) ||
            (this.searchParm['schoolName'] &&
                this.searchParm['schoolName'] == '' &&
                this.searchParm['schoolAddress'] &&
                this.searchParm['schoolAddress'] == '' &&
                this.searchParm['cdsCode1'] &&
                this.searchParm['cdsCode1'] == '' &&
                this.searchParm['cdsCode2'] &&
                this.searchParm['cdsCode2'] == '' &&
                this.searchParm['cdsCode3'] &&
                this.searchParm['cdsCode3'] == '' &&
                this.searchParm['schoolCity'] &&
                this.searchParm['schoolCity'] == '')
        ) {
            if (bCountysIsBlank && bRegionsIsBlank && bDistrictsIsBlank) {
                console.log('recognized blank filters');
                this.child2.myError = 'Please input into one of the above fields.';
                return;
            }
        } else {
            this.child2.myError = '';
        }
        this.child.getSpecificSchoolDistricts(true);
    }

    onResetMe() {
        console.log('selected county');
        //console.log(this.child5.selectedCountyName);
        this.child6.child3.selectedCountyIds = [];
        this.child6.child3.reset = true;
        this.child6.child3.deSelectAll();
        this.child6.child2.deSelectAll();
    }

    searchParmEvent(inSearchParm: any) {
        console.log("called parent's searchParm():" + inSearchParm);
    }

    catchSearchError(err: any) {
        console.log('search schools caught error:' + err);
        this.child2.myError = 'No school results. Please check your input.';
        this.isLoadingResults = false;
    }

    getSpecificDistrict(id: number): SchoolDistrict | null {
        for (var i = 0; i < this.allSchoolDistricts.length; i++) {
            if (this.allSchoolDistricts[i].ID == id) {
                return this.allSchoolDistricts[i];
            }
        }
        return null;
    }

    countiesInputSelected(counties: any) {
        this.selectedCounties = counties;
    }

    regionsInputSelected(regions: any) {
        this.selectedRegions = regions;
    }

    districtsInputSelected(districts: any) {
        this.selectedDistricts = districts;
    }

    // CREATE methods start here
    getSchoolDistrict(thisSchoolDistrictId: number) {
        console.log('passing in schoolid:' + thisSchoolDistrictId);
        this.schoolDistrictsAPIService.show(thisSchoolDistrictId).subscribe((res) => {
            console.log('thisSchoolDistrict: ');
            this.schoolDistrict = res.school;
            console.log(this.schoolDistrict);
        });
    }

    districtsSelected(districts: SchoolDistrict[]) {
        var editDistrict: any;

        if (districts[0] && this.child5.selectedCountyName != undefined) {
            editDistrict = this.getSpecificDistrict(districts[0].ID);

            this.schoolDistrict.DISTRICTS = editDistrict;

            this.selectedNcesCode = this.schoolDistrict.NCESDist.toString();
            this.ncesCode = this.selectedNcesCode;
        }
    }

    // edit-contact-mechanisms functions
    fnCreate() {
        console.log("calling Search & Create's fnCreate");
        this.myError = '';
        this.isUneditable = !this.isUneditable;
        if (!this.isUneditable) {
            this.createBtnText = 'Creating...';
            this.bCancelCreate = true;
        } else {
            this.bCancelCreate = false;
            this.createBtnText = 'Create';
        }
    }

    fnSetInitialData() {
        console.log('setting initial school district data');
        //       const districtShell = this.editData['SCHOOL_DISTRICT'];

        //     const districtOrganization = districtShell['Organization'];
        //   if (districtOrganization) {
        //      console.log('OrganizationDistrict:' + Object.entries(districtOrganization));
        //   }
        //   this.schoolDistrictID = this.editData['ID'];

        /* this.schoolDistrictsAPIService.show(this.schoolDistrictID).subscribe((res) => {
            console.log('thisSchoolDistrict: ');
            this.schoolDistrict = res.schoolDistrict;
            console.log(this.schoolDistrict);
   
            this.selectedDistrict = this.schoolDistrict.ID!;
            this.selectedSchoolDistrict = this.schoolDistrict.ID!;

            this.schoolDistrictNCES = this.schoolDistrict.NCESDist.toString() || '';
            this.selectedNcesCode = this.schoolDistrict.NCESDist.toString() || '';
            this.schoolDistrictName = this.schoolDistrict.DISTRICTS;
            this.schoolDistrictCode = this.schoolDistrict.CODE;

            var translateCounty = Object.values(this.editData['COUNTy']).toString().split(',');

            this.isLoading = false;
            this.isCreated = false;

            this.fnCheckNCESDistrictCode();
*/
        // backup for screenBackup save functionality
        /*this.schoolBackup = JSON.parse(JSON.stringify(this.school));
  console.log("new backup set for school");
  console.log(this.schoolBackup);
  */
        // });
    }

    getPartyRoles() {
        console.log('getting party roles for user:' + Object.entries(this.user));
        this.userProfileService.getPartyRoles(this.user!.PERSON!.PARTy!.ID!).subscribe((res) => {
            if (res?.partyRoles) {
                this.partyRoles = res.partyRoles;
                console.log('got party roles:' + res.partyRoles);
            }
        });
    }

    getRegionsByPartyId() {
        this.userProfileService.getRegionsByPartyId(this.user!.PERSON!.PARTy!.ID!).subscribe((res) => {
            if (res?.regions) {
                this.regions = res.regions;
            }
        });
    }

    subscribers() {
        let schoolRegionsEntitiesSub = this.schoolRegionService.entities$.subscribe((schoolRegions: Region[]) => {
            this.allSchoolRegions = schoolRegions;
            this.schoolRegionIds = this.allSchoolRegions.length > 0 ? this.allSchoolRegions.map((schoolRegion) => schoolRegion.ID!) : [];
        });

        let schoolDistrictEntitiesSub = this.schoolDistrictService.entities$.subscribe((schoolDistricts: SchoolDistrict[]) => {
            this.allSchoolDistricts = schoolDistricts;
            this.schoolDistrictIds = this.allSchoolDistricts.length > 0 ? this.allSchoolDistricts.map((schoolDistrict) => schoolDistrict.ID!) : [];
        });

        let schoolCountyEntitiesSub = this.schoolCountyService.entities$.subscribe((schoolCounties: County[]) => {
            this.allSchoolCounties = schoolCounties;
        });
    }

    onCreateEvent(inCreateParm: any) {
        this.bShowCreateForm = true;
        this.bCancelCreate = true;
        this.createBtnText = 'Creating...';
        this.isUneditable = !this.isUneditable;
        console.log('onCreateEvent called');
    }
}
